import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const roles = [{
  id: 'marketing',
  label: 'Marketing',
  headline: 'Prove what every dollar of spend returns.',
  points: ['True multi-touch attribution across paid, organic and email', 'Blend ad spend with pipeline to see real CAC and ROAS', 'Sync winning audiences back to Meta, Google and LinkedIn']
}, {
  id: 'sales',
  label: 'Sales',
  headline: 'Reach the right account at the exact right moment.',
  points: ['Real-time intent alerts routed straight to the rep', 'Account timelines that merge product, web and CRM activity', 'Scores that combine fit, engagement and buying signals']
}, {
  id: 'revops',
  label: 'RevOps',
  headline: 'One trusted number the whole board agrees on.',
  points: ['A single unified model instead of a dozen conflicting reports', 'Anomaly detection on spend, conversion and pipeline health', 'Governed, exportable data ready for Snowflake or the CFO']
}];
export function UseCases() {
  const [active, setActive] = useState(roles[0].id);
  const current = roles.find(r => r.id === active) ?? roles[0];
  return <section className="bg-ink py-20 text-cream md:py-28" data-id="element-208">
      <div className="mx-auto max-w-[1200px] px-5 md:px-8" data-id="element-209">
        <h2 className="max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-tight md:text-6xl" data-id="element-210">
          Built for everyone who owns a number.
        </h2>

        <div className="mt-10 flex flex-wrap gap-2" data-id="element-211">
          {roles.map(r => <button key={r.id} onClick={() => setActive(r.id)} className={`rounded-full px-5 py-2.5 text-sm font-semibold transition-colors ${active === r.id ? 'bg-signal text-white' : 'border border-cream/25 text-cream/70 hover:text-cream'}`} data-id="element-212">
              {r.label}
            </button>)}
        </div>

        <AnimatePresence mode="wait" data-id="element-213">
          <motion.div key={current.id} initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -16
        }} transition={{
          duration: 0.35
        }} className="mt-12 grid gap-10 border-t border-cream/15 pt-12 lg:grid-cols-[1.2fr_1fr]" data-id="element-214">
            <h3 className="font-display text-3xl font-semibold leading-tight md:text-5xl" data-id="element-215">
              {current.headline}
            </h3>
            <ul className="space-y-5" data-id="element-216">
              {current.points.map(p => <li key={p} className="flex gap-4 border-b border-cream/10 pb-5 text-lg text-cream/80" data-id="element-217">
                  <span className="font-display text-signal" data-id="element-218">→</span>
                  {p}
                </li>)}
            </ul>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>;
}